"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const vue_class_component_1 = __importDefault(require("vue-class-component"));
console.log("vue @Component: ", vue_class_component_1.default);
const compname = "my-ts-component";
// The @Component decorator indicates the class is a Vue component
/*
@Component({
  name: "my-ts-component",
  // All component options are allowed in here
  //template: '<button @click="onClick">Click!</button>'
  template: '<div><span style="font-size: 50px; color: red;">This is MyTsComponent</span></div>'
})
export default class MyTsComponent extends Vue {
  // Initial data can be declared as instance properties
  message: string = 'Hello!';

  // Component methods can be declared as instance methods
  onClick (): void {
    window.alert(this.message)
  }
}
(window as any).vueComponentVms["my-ts-component"] = new MyTsComponent();
 */
let MyTsComponent = class MyTsComponent extends vue_1.default {
    constructor() {
        super(...arguments);
        this.foo = "bar!";
    }
    teePrkl() {
        return __awaiter(this, void 0, void 0, function* () {
            alert("prkl!");
        });
    }
};
MyTsComponent = __decorate([
    vue_class_component_1.default({
        name: compname,
        template: '<h1 style="font-size:50px;color:red;" @click="teePrkl">mytscomp! {{foo}}</h1>',
    })
], MyTsComponent);
exports.default = MyTsComponent;
window[compname] = vue_1.default.component(compname, MyTsComponent);
// TODO: ainaki vue importilla kusee mut tällä toimii, pitäis kaikki vaihtaa -> ts ... tai miten ignoorataan webpackissa depsu joka tulee toisin??? NÄIN: https://webpack.js.org/configuration/externals/ ... JOO TOIMII ILM
//let Vue = (window as any).Vue;
//let myTsComponent = Vue.component('my-ts-component', {
/*
let myTsComponent = Vue.extend({
  template: '<h1 style="font-size:50px;color:red;">mytscomp!!</h1>',
});
//(window as any).vueComponentVms["my-ts-component"] = myTsComponent;
window[compname] = Vue.component(compname, myTsComponent); // näin tehdään myös vueapp.js:ssä - TODO: mut mihis tätä nyt enää tarvitaan ja sais olla kyllä joku window.vueComponents[..]
console.log("vue created component '"+compname+"': ",window[compname]);
 */
/*
let myTsComponent = {
  template: '<h1 style="font-size:50px;color:red;">mytscomp!</h1>',
  _vueCompName: "my-ts-component",
};
(window as any).vueComponentVms["my-ts-component"] = myTsComponent;

 */
